import React from 'react';
import classNames from 'classnames';
import './index.scss';

interface IProps {
  className?: string;
  style?: any;
  children?: any;
}

// 用于设置className和配置话tab包裹组件
const CommonTabContentWrap = (props: IProps) => {
  const { className = '', style, children, ...resetProps } = props || {};
  return (
    <div className={classNames('dbh-studio-common-tab-content-wrap', className)} style={style}>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(
          child,
          { ...resetProps }
        );
      })}
    </div>
  );
};

export default CommonTabContentWrap;